import type { BrightnessLandTuning, SquashLandTuning } from "@slot/presentation";

/** The symbols that squash when they land: the scatter. */
export const SQUASH_LAND_SYMBOL_IDS: readonly string[] = ["FS"];

/** The symbols that shine when they land: the scatter and the VS battle wild. */
export const SHINE_LAND_SYMBOL_IDS: readonly string[] = ["FS", "VS"];

/**
 * The FS squash-and-settle pop when a scatter lands. Scales are multipliers on the cell's rest scale, durations
 * seconds; nothing waits for the pop (decision 20).
 */
export const SQUASH_LAND_TUNING: SquashLandTuning = {
  squashScaleX: 1.15, // widen 15% at peak
  squashScaleY: 0.85, // flatten 15% at peak
  squashSeconds: 0.08, // quick squash in
  squashEasing: "quadOut",
  settleSeconds: 0.16, // settle back to rest
  settleEasing: "backOut", // slight overshoot pop
  squashOffsetX: 0,
  squashOffsetY: -10, // shift the content DOWN at peak so the squash squeezes to the BOTTOM
};

/** The brightness shine when a scatter or a VS lands, composed with the squash. */
export const LAND_SHINE_TUNING: BrightnessLandTuning = {
  peak: 2, // apex exposure gain above 1×: 0 = untouched, 1 = 2×, 2 = 3×
  startDelayMilliseconds: 0, // shine right as it lands
  rampUpSeconds: 0.05,
  rampUpEasing: "quadOut",
  holdSeconds: 0.01,
  rampDownSeconds: 0.3,
  rampDownEasing: "quadIn",
};
